import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgNote({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M43.812 10.316a3.696 3.696 0 0 0-3.696-3.696H36.42a.462.462 0 0 1-.462-.462v-2.31a1.848 1.848 0 0 0-3.697 0v7.684a1.848 1.848 0 0 0 3.697 0v-.754c0-.255.206-.462.462-.462h2.772c.51 0 .924.414.924.924v19.405c0 .51-.414.924-.924.924h-5.544a3.696 3.696 0 0 0-3.697 3.696v5.544c0 .51-.413.925-.924.925H7.774a.924.924 0 0 1-.924-.925V11.24c0-.51.414-.924.924-.924h1.849a.462.462 0 0 0 .462-.462V7.082a.462.462 0 0 0-.462-.462H6.85a3.696 3.696 0 0 0-3.696 3.696v31.418A3.696 3.696 0 0 0 6.85 45.43H31.8c.517 0 1.011-.218 1.361-.6l10.165-11.087c.313-.341.486-.787.486-1.25V10.316Z" />
            <path d="M23.945 13.38c1.02 0 1.848-.827 1.848-1.848v-.754c0-.255.207-.462.462-.462h3.696a.462.462 0 0 0 .462-.462V7.082a.462.462 0 0 0-.462-.462h-3.696a.462.462 0 0 1-.462-.462v-2.31a1.848 1.848 0 1 0-3.696 0v7.684c0 1.021.827 1.848 1.848 1.848ZM13.78 13.38c1.021 0 1.849-.827 1.849-1.848v-.754c0-.255.207-.462.462-.462h3.696a.462.462 0 0 0 .462-.462V7.082a.462.462 0 0 0-.462-.462H16.09a.462.462 0 0 1-.462-.462v-2.31a1.848 1.848 0 0 0-3.696 0v7.684c0 1.021.827 1.848 1.848 1.848Z" />
        </svg>
    )
}
SvgNote.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgNote
